import React, { memo } from 'react';

const BigHeartCare = memo(({ size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3093 44.0301L24.5859 43.3068"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7613 34.6734L15.0146 33.9268"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7524 38.7333L37.6357 38.8033"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8595 29.89L10.5794 29.61L8.10478 27.16C6.35391 25.4567 5.4668 22.4233 5.4668 19.5767C5.4668 12.6467 11.233 7 18.3065 7C22.6254 7 26.4773 9.1 28.8118 12.32C31.123 9.1 34.9749 7 39.2937 7C46.3672 7 52.1335 12.6467 52.1335 19.5767C52.1335 22.4233 51.2464 25.4567 49.4955 27.16L46.9742 29.6333H46.9509"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.3983 34.16L42.375 34.1834"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4312 39.2233L19.8945 38.7333"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.8352 12.3201L24.96 16.2867C31.2865 22.6334 35.2551 17.8034 35.2551 17.8034L39.1771 21.7467L46.9043 29.5167C46.9043 29.5167 48.8886 31.3601 46.9043 33.3434C44.9199 35.3267 43.0056 34.7667 42.3987 34.1601L34.7649 26.4834"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5782 26.3668L42.3054 34.1368C42.3054 34.1368 44.2897 35.9801 42.3054 37.9634C40.3211 39.9468 38.4068 39.3868 37.7998 38.7801L30.166 31.1034"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.9092 31.0568L37.6364 38.8268C37.6364 38.8268 39.6207 40.6701 37.6364 42.6535C35.652 44.6368 33.1308 44.3101 31.4033 42.5835"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.4857 31.2666C16.4857 32.0133 16.1823 32.7366 15.6453 33.3199L13.8711 35.0933C12.7505 36.2133 10.9063 36.2133 9.78573 35.0933C9.22545 34.5333 8.94531 33.7866 8.94531 33.0399C8.94531 32.2933 9.22545 31.5466 9.78573 30.9633L10.8596 29.8899L11.56 29.2133C12.6805 28.0699 14.5248 28.0699 15.6453 29.2133C16.1823 29.7966 16.4857 30.5199 16.4857 31.2666Z"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9446 36.4699C20.9446 37.2165 20.6412 37.9632 20.1042 38.5232L19.8941 38.7332L18.33 40.2965C17.2094 41.4165 15.3652 41.4165 14.2446 40.2965C13.6843 39.7132 13.3809 38.9899 13.3809 38.2432C13.3809 37.4965 13.6843 36.7499 14.2446 36.1665L15.7387 34.6732L15.9955 34.4165C17.1394 33.2732 18.9603 33.2732 20.1042 34.4165C20.6412 34.9765 20.9446 35.7232 20.9446 36.4699Z"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.9164 40.7165C25.9164 41.4632 25.6129 42.2099 25.076 42.7932L24.5857 43.2832L23.3251 44.5199C22.2046 45.6632 20.3603 45.6632 19.2164 44.5199C18.6795 43.9365 18.376 43.2132 18.376 42.4665C18.376 41.7199 18.6795 40.9965 19.2164 40.4132L20.9906 38.6399C22.1112 37.5199 23.9554 37.5199 25.0993 38.6399C25.6363 39.1999 25.9398 39.9465 25.9398 40.6932L25.9164 40.7165Z"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9867 44.31V44.3567C31.9634 45.08 31.6832 45.8267 31.1463 46.3867L29.3954 48.1367C28.2515 49.28 26.4073 49.28 25.2867 48.1367C24.7264 47.5533 24.4463 46.83 24.4463 46.0833C24.4463 45.3367 24.7264 44.6133 25.2867 44.03H25.3101L27.0609 42.2567C28.1815 41.1367 30.0257 41.1367 31.1463 42.2567C31.7066 42.8167 31.9867 43.5633 31.9867 44.31Z"
        stroke="#B31A20"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

export default BigHeartCare;
